module.exports = __webpack_public_path__ + "name=img/node_modules/html5-device-mockups/device-mockups/iMac/portrait_black.png?81750ebff2148b5c149031d44649dd25";